import { Injectable } from '@angular/core';

import { AppState } from '../app-state';
import { pathSchema, pathPullQueryBuilder } from '../schema/path-schema';
import { RestClient } from './rest-client';
import { HttpClient } from '@angular/common/http';
import { Path } from '../models';
import { TestbedRxdbGraphQlCollectionService, TestbedRxdbState } from './testbed-rxdb';
import { RxDocument } from 'rxdb';
import { AuthenticationService } from './authentication.service';

// basic service to read postgres 'path' table (needs connection and does not work in offline mode)

class PathRestClient extends RestClient<Path> {
  constructor(http: HttpClient, appState: AppState) {
    super(http, "path", appState);
  }
}
  
export type PathDoc = RxDocument<Path,{}>

@Injectable({ providedIn: "root" })
export class PathRxdbService extends TestbedRxdbGraphQlCollectionService<
  Path,
  PathDoc
> {
  restClient: PathRestClient;
  constructor( appState : AppState, authService: AuthenticationService, rxdbState: TestbedRxdbState, http: HttpClient ) {
    super("path", pathSchema, appState, rxdbState, authService);
    this.syncConfig = {
      push: false,
      pull: true,
      intervalMs: appState.settings.get("rxdb.collections.path.intervalMs", 0),
      retry: true,
      bGraphQL: true,
      query: pathPullQueryBuilder(),
      graphQLSubscription: `subscription{
                pathUpdated{
                    paths{
                        id
                    }
                }
            }`,
    };
    this.restClient = new PathRestClient(http, appState);
  }
  
  update(path: Path) {
    return this.restClient.http.patch(this.restClient.urlPath, path, {
      observe: "response",
    });
  }
}



